/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import PropTypes from 'prop-types'

import Button from 'components/_atoms/Button'

import './styles.css'

const ButtonGroup = ({ options, small }) => {
  return (
    <div data-component="ButtonGroup">
      {options.map(option => (
          <Button
            key={option.content}
            inverse={!option.selected}
            onClick={option.action}
            className="grouped"
            small
          >
            {option.content}
          </Button>
        )
      )}
    </div>
  )
}

ButtonGroup.propTypes = {
  options: PropTypes.array.isRequired,
  small: PropTypes.bool,
}

ButtonGroup.defaultProps = {
  small: false,
}

export default ButtonGroup



// WEBPACK FOOTER //
// ./src/components/_atoms/ButtonGroup/index.js